import {useState} from 'react';
import {Stack, Typography} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {FishGroupOptionsMenu} from './FishGroupOptionsMenu';
import {useTranslation} from 'react-i18next';

export interface FishGroupRowDateRangeProps {
  label: string;
  icon?: JSX.Element;
  startDate: string;
  endDate: string;
  options?: string[];
}

export const FishGroupRowDateRange = ({
  label,
  icon,
  startDate,
  endDate,
  options,
}: FishGroupRowDateRangeProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const {t} = useTranslation('common');

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const isMixed: boolean = !!(options && options.length > 1);

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Stack direction={'row'} width={90}>
        <Typography variant="body2" color={'secondary'}>
          {label}
        </Typography>
      </Stack>

      {options && (
        <FishGroupOptionsMenu options={options} open={open} anchorEl={anchorEl} handleCloseMenu={handleCloseMenu} />
      )}

      {isMixed ? (
        <Stack direction={'row'} spacing={1} alignItems={'center'} onClick={handleOpenMenu} sx={{cursor: 'pointer'}}>
          {icon}
          <Typography variant="body2">{t('mixed')}</Typography>
        </Stack>
      ) : (
        <Stack direction={'row'} spacing={1} alignItems={'center'} onClick={handleOpenMenu}>
          {icon}
          <Typography variant="body2">{startDate}</Typography>
          <ArrowForwardIcon fontSize="inherit" />
          <Typography variant="body2">{endDate}</Typography>
        </Stack>
      )}
    </Stack>
  );
};
